<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab4.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab4.text1', $t, localPath)"></span></p>
                                        <div class="buttons sub-cont">
                                        <a :href="getExternalUrl('/register/1/live-account')" target="_blank" rel="noopener noreferrer">
                                            <button class="primary-button-medium">
                                                {{ $t("faq.tab4.btn") }}
                                            </button>
                                        </a>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                <div class="content-main-tab">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab4.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab4.text1', $t, localPath)"></span></p>
                                    <div class="buttons sub-cont">
                                    <a :href="getExternalUrl('/register/1/live-account')" target="_blank" rel="noopener noreferrer">
                                        <button class="primary-button-medium">
                                            {{ $t("faq.tab4.btn") }}
                                        </button>
                                    </a>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
import { useExternalUrl } from '@/composables/useExternalUrl';
const { getExternalUrl } = useExternalUrl();

const { t, locale } = useI18n();
const route = useRoute();
const localPath = useLocalePath();
import FaqAccordion from '~/components/faq/FaqAccordion.vue'

useFaqSeoMeta("faq.tab4.title1", "faq.tab4.text1");
</script>

